import theme from 'src/libs/styled-components/theme';
import { IconProps } from '..';

export default function IconSearch({
  width = 16,
  height = 16,
  color = theme.palette.bg400
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.5 13.375L10.6225 9.49687C11.2474 8.63817 11.5835 7.60325 11.5825 6.54125C11.5825 3.76156 9.32094 1.5 6.54125 1.5C3.76156 1.5 1.5 3.76156 1.5 6.54125C1.5 9.32094 3.76156 11.5825 6.54125 11.5825C7.60325 11.5835 8.63817 11.2474 9.49687 10.6225L13.375 14.5L14.5 13.375ZM6.54125 9.99031C5.859 9.99037 5.19206 9.78812 4.62476 9.40912C4.05747 9.03012 3.6153 8.4914 3.35419 7.8611C3.09308 7.2308 3.02474 6.53722 3.15783 5.86807C3.29091 5.19893 3.61944 4.58428 4.10186 4.10186C4.58428 3.61944 5.19893 3.29091 5.86807 3.15783C6.53722 3.02474 7.2308 3.09308 7.8611 3.35419C8.4914 3.6153 9.03012 4.05747 9.40912 4.62476C9.78812 5.19206 9.99037 5.859 9.99031 6.54125C9.98924 7.45567 9.62551 8.33233 8.97892 8.97892C8.33233 9.62551 7.45567 9.98924 6.54125 9.99031Z"
        fill={color}
      />
    </svg>
  );
}
